/*
    Account.js - Account model
 */

import {Rest} from '@/paks/vu-app'

export default new Rest(
    'Account',
    {
        close: {method: 'POST', uri: '/:controller/close'},
        credit: {method: 'POST', uri: '/:controller/credit'},
        make: {method: 'POST', uri: '/:controller/make'},
        suspend: {method: 'POST', uri: '/:controller/suspend'},
        updateIdentity: {method: 'POST', uri: '/:controller/updateIdentity'},
    },
)
